/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * Severity level
 * * MINOR
 * * MAJOR
 * * CRITICAL
 * * BLOCKING
 */
export enum Severity {
  MINOR = 'MINOR',
  MAJOR = 'MAJOR',
  CRITICAL = 'CRITICAL',
  BLOCKING = 'BLOCKING'
}
